import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0A1128] px-6 text-center" data-testid="payment-cancel">
      <XCircle className="text-[#C0392B]" size={48} />
      <p className="mt-4 text-lg font-semibold text-white">Zahlung abgebrochen</p>
      <p className="mt-1 text-sm text-[#A0AEC0]">Du kannst die Freischaltung jederzeit erneut starten.</p>
      <button
        data-testid="payment-cancel-retry"
        onClick={() => navigate("/berater", { replace: true })}
        className="mt-6 rounded-full bg-[#C5A059] px-6 py-3 text-sm font-semibold text-[#0A1128]"
      >
        Zurück
      </button>
    </div>
  );
}
